import React from 'react';

export default function Card({ title, content, icon = null, action  = null, variant = ""}){
    return (
        <div className={`card ${variant}`}>
            <div className="text-area">
                <div className="card-title">{title}</div>
                <div className="card-content">{content}</div>
            </div>
            {icon && (
                <div className="icon-area" onClick={action}>
                    {icon}
                </div>
            )}
        </div>
    );
}